import React, { RefObject } from 'react';
import { useZoomPan } from '../hooks/useZoomPan';
import { CONSTANTS } from '../data.js';

type ChildrenType = React.ReactNode | ((zoom: number) => React.ReactNode);

interface Props {
  scrollRef: RefObject<HTMLDivElement>;
  contentRef: RefObject<HTMLDivElement>;
  onZoomChange?: (z: number) => void;
  children: ChildrenType;
}

export function WorkbenchViewport({ scrollRef, contentRef, onZoomChange, children }: Props) {
  const { zoom, handlers } = useZoomPan({
    scrollRef,
    contentRef,
    onZoomChange
  });

  const renderedChildren = typeof children === 'function' ? (children as (z: number) => React.ReactNode)(zoom) : children;

  return (
    <div
      ref={scrollRef}
      className="flex-grow relative overflow-hidden cursor-grab"
      style={{ backgroundColor: 'rgba(15,23,42,0.4)' }}
      onMouseDown={handlers.onMouseDown}
      onMouseMove={handlers.onMouseMove}
      onMouseUp={handlers.onMouseUp}
      onMouseLeave={handlers.onMouseLeave}
      onWheel={handlers.onWheel}
    >
      <div
        ref={contentRef}
        className="relative"
        style={{
          width: `${CONSTANTS.WORKBENCH_WIDTH}px`,
          height: `${CONSTANTS.WORKBENCH_HEIGHT}px`,
          transform: `scale(${zoom})`,
          transformOrigin: 'top left',
          willChange: 'transform',
          backfaceVisibility: 'hidden',
          WebkitFontSmoothing: 'auto',
          MozOsxFontSmoothing: 'auto',
          textRendering: 'optimizeSpeed',
          imageRendering: 'auto'
        }}
      >
        {renderedChildren}
      </div>
    </div>
  );
}
